<template>
  <el-dialog
    :title="$t('SeaExport.PreviewOfBookingFileParsing')"
    custom-class="intelligent-booking-result-dialog"
    :visible.sync="innerVisible"
    fullscreen
    :modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
  >
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column;overflow: auto">
      <el-tabs v-model="activeTabName" type="card" style="margin-top: 8px;" @tab-click="handleClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_identifyTheResult')" name="identifyResult">
          <cargo-left-right-resize
            style="width:100%;height: 100%;"
            :left-style="{'min-width': '550px',width:'50%'}"
            :right-style="{'min-width': '550px',width:'50%'}"
          >
            <template slot="left">
              <div style="width: 100%;height:100%;overflow: auto;">
                <image-preview-by v-if="visible" :details="details" :cur-focus="curFocus" />
              </div>
            </template>
            <template slot="right">
              <span style="font-size: 16px;padding-left: 20px">{{ $t('CargoMsg.Cargo_identifyTheResult2') }}</span>
              <div v-if="details.identificationType === SENDING_2.code" style="width: 100%;height:100%;overflow: auto;">
                <result-form-bill-by v-if="visible" ref="resultForm1" :details="details" @fieldFocus="(val)=>curFocus=val" />
              </div>
            </template>
          </cargo-left-right-resize>
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_ContrastingSystem')" name="ContrastingSystem">
          <cargo-left-right-resize
            style="width:100%;height: 100%;"
            :left-style="{'min-width': '550px',width:'50%'}"
            :right-style="{'min-width': '550px',width:'50%'}"
          >
            <template slot="left">
              <span style="font-size: 16px;padding-left: 20px">{{ $t('CargoMsg.Cargo_identifyTheResult2') }}</span>
              <result-form-bill-by v-if="visible" ref="resultForm2" :job-uuid="comparisonDetail.jobUuid" :details="comparisonDetail" @fieldFocus="(val)=>curFocus=val" />
            </template>
            <template slot="right">
              <span style="font-size: 16px;padding-left: 20px">{{ $t('CargoMsg.Cargo_SystemResult') }}</span>
              <result-form-bill-by v-if="visible" ref="resultForm3" :show-job="true" :job-uuid="comparisonDetail.jobUuid" :details="comparisonDetail" @fieldFocus="(val)=>curFocus=val" />
            </template>
          </cargo-left-right-resize>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="details.status === 3" slot="footer" style="text-align: center">
      <el-button no="1" @click="handleClose">{{ $t('Message.Close') }}</el-button>
    </div>
    <div v-else slot="footer" style="text-align: center;">
      <el-button v-if="activeTabName === 'identifyResult'" no="2" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button v-if="activeTabName === 'ContrastingSystem'" no="3" @click="handleSave">{{ $t('CargoMsg.Cargo_SaveBillData') }}</el-button>
      <el-button v-if="activeTabName === 'ContrastingSystem'" no="4" type="primary" @click="coveringBillHandler">{{ $t('CargoMsg.Cargo_SaveBill2') }}</el-button>
      <el-button no="5" @click="handleClose">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreviewBy from '@/views/cargo/v0/ToolAssistant/ocr/components/ImagePreviewBy'
import ResultFormSeBy from '@/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeBy'
import ResultFormSiBy from '@/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSiBy'
import ResultFormBillBy from '@/views/cargo/v0/ToolAssistant/ocr/components/ResultFormBillBy'
import { saveResultJsonByFunc } from '@/api/seaExport/intelligentBooking'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { SENDING_0, SENDING_1, SENDING_2 } from '@/class/cargo/model/parameters/SystemConstants'
import lodash from 'lodash'

export default {
  name: 'IntelligentBookingResultBy',
  components: { ResultFormSeBy, ResultFormSiBy, ResultFormBillBy, ImagePreviewBy, CargoLeftRightResize },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      curFocus: '',
      SENDING_0,
      SENDING_1,
      SENDING_2,
      activeTabName: 'identifyResult'
    }
  },
  computed: {
    resultJson() {
      return this.details.resultJson ? JSON.parse(this.details.resultJson) : null
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    },
    comparisonDetail() {
      return lodash.cloneDeep(this.details)
    }
  },
  methods: {
    handleClick() {},
    // 识别内容覆盖业务
    async coveringBillHandler() {
      const resultJson = this.$refs.resultForm2.getSubmitData()
      // this.$emit('close')
      const params = {
        uuid: this.details.uuid,
        saveType: 2,
        resultJson: resultJson
      }
      this.doSave(params)
    },
    // 保存识别内容
    saveHandler() {
      const result = this.$refs.resultForm1.resultJson
      // 发货人
      this.scnChange(result, 'shipper')
      // 收货人
      this.scnChange(result, 'consignee')
      // 通知人
      this.scnChange(result, 'notify')
      const params = {
        uuid: this.details.uuid,
        saveType: 0,
        resultJson: result
      }
      this.doSave(params, 1)
    },
    // 保存业务内容
    handleSave() {
      const resultJson = this.$refs.resultForm3.getSubmitData()
      const params = {
        uuid: this.details.uuid,
        saveType: 1,
        resultJson: resultJson
      }
      this.doSave(params)
    },
    doSave(params, skip) {
      const loading = getLoading4Cxt(this)
      saveResultJsonByFunc(params).then(res => {
        // 这里不关闭页面 跳转到第二个页签
        // if (skip) {
        // this.details.resultJson = this.$refs.resultForm1.resultJson
        // this.activeTabName = 'ContrastingSystem'
        // } else {
        //
        // }
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('success')
      }).finally(() => {
        loading.close()
      })
    },
    scnChange(result, field) {
      let data = ''
      for (let i = 1; i <= 7; i++) {
        if (i > 1) {
          data += '\n'
        }
        const key = field + 'Line' + i
        if (result[key]) {
          data += result[key].toUpperCase()
        }
      }
      result[field] = data
    },
    handleClose() {
      console.log('result close')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking-result-dialog{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body{
    padding: 0!important;
    display: flex;
    flex:1;
    overflow: hidden;
  }
}
</style>
